export enum ProjectTypeEnum {
  PRE_SALES = "pre_sales",
  POST_SALES = "post_sales",
}
